module.exports = __webpack_public_path__ + "img/2_111.01fbb31b.png";